import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { getRedirectPath, isPathAllowedForRole } from '@/utils/auth-redirect'
import type { ReactElement } from 'react'

export function ProtectedRoute({ children }: { children: ReactElement }) {
  const { user, initializing } = useAuth()
  const location = useLocation()

  if (initializing) {
    return (
      <div className='flex h-screen items-center justify-center bg-[#F8F9FA]'>
        <div className='h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-gray-900' />
      </div>
    )
  }

  if (!user) {
    return (
      <Navigate
        to='/login'
        state={{ redirectTo: location.pathname }}
        replace
      />
    )
  }

  // Redirect users who try to access routes not allowed for their role
  if (!isPathAllowedForRole(location.pathname, user.role)) {
    const allowedPath = getRedirectPath(user)
    return <Navigate to={allowedPath} replace />
  }

  return children
}
